<template>
  <div id="login">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <div class="login-wrapper">
      <div class="login-container">
        <img src="../../assets/logo-white.png" class="logo-img small" alt="">
        <!-- <h1>SVTN</h1>
        <p v-html="$t('acc.login.title')"></p> -->
        <div class="form-area">
          <form-input
            :inputType="typeEmail"
            :placeholderText="emailHolder"
            :inputValue="email"
            @inputParent="value => { email = value }"
            @keyup.enter.native="nextInputFocus"
          />
          <form-input
            ref="passwd"
            :inputType="typePW"
            :placeholderText="pwHolder"
            :inputValue="password"
            @inputParent="value => { password = value }"
            @keyup.enter.native="normalLogin(email, password)"
          ></form-input>
          <form-button
            :btnName="buttonName"
            @click.native="normalLogin(email, password)"
          ></form-button>
        </div>
        <p class="text-links">
          <a @click="goPage('/acc/signup')">{{ $t('acc.login.signUpByEmail') }}</a>
          | <router-link to="/acc/find/pw">{{ $t('acc.login.findPassWord') }}</router-link></p>
        <div class="sns-share-btns">
          <p>{{ $t('acc.login.curAccountLogin') }}</p>
          <a @click="performFbLogin" class="sns-btn" style="cursor:pointer">
            <img src="../../assets/logo-facebook.png" alt="">
          </a>
          <a v-bind:href="loadNaverLogin" class="sns-btn">
            <img src="../../assets/logo-naver.png" alt="">
          </a>
          <a @click="performKakaoLogin" class="sns-btn" style="cursor:pointer">
            <img src="../../assets/logo-kakao.png" alt="">
          </a>
        </div>
        <p class="terms-links" :is=transForm>
        </p>
      </div>
    </div>
    <comp-modal
      v-if="showModal"
      titleShow
      @confirm="showModal = false"
    >
      <h3 slot="header">{{ titleModal }}</h3>
      <p slot="body" v-html="msgModal"></p>
    </comp-modal>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
    <comp-modal
      v-if="friendsModal"
      @confirm="goPage('/match/list')"
    >
      <p slot="body">{{friendsModalBody}}</p>
    </comp-modal>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import common from '@/utils/common';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import RESPONSE from '@/constants/response';
import FormInput from '@/components/FormInput';
import FormButton from '@/components/FormButton';
import SOCIAL from '@/constants/social';
import LOGIN_TYPE from '@/constants/loginType';
import TEST from '@/constants/test';
import { loadFbSdk } from '@/utils/social';
import md5 from 'md5';

export default {
  name: 'login',
  mixins: [
    common,
  ],
  data() {
    return {
      isFbReady: false,

      typeEmail: 'email',
      typePW: 'password',
      checkbox: 'checkbox',

      emailHolder: this.$i18n.t('common.email'),
      pwHolder: this.$i18n.t('common.password'),

      buttonName: this.$i18n.t('common.login'),

      email: '',
      password: '',

      showModal: false,
      titleModal: '',
      msgModal: '',
      facebookStatus: '',

      isLoading: false,

      friendsModalBody: '',
      friendsModal: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    FormInput,
    FormButton,
    CompModal,
    CompLoading,
  },
  computed: {
    transForm() {
      return {
        template: this.$i18n.t('acc.login.terms'),
      };
    },
    loadNaverLogin() {
      this.$store.commit('setLoginType', LOGIN_TYPE.NAVER);

      const callbackURI = encodeURIComponent(`${process.env.NAVER_REDIREICT_URI}`);
      const state = md5('svtn_state');
      let url = 'https://nid.naver.com/oauth2.0/authorize?response_type=code';
      url += `&client_id=${SOCIAL.NAVER_CLIENT_ID}`;
      url += `&redirect_uri=${callbackURI}`;
      url += `&state=${state}`;
      return url;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    nextInputFocus() {
      this.$refs.passwd.$refs.input.focus();
    },
    normalLogin(email, password) {
      if (this.showModal) {
        this.showModal = false;
        return;
      }

      this.$store.commit('setLoginType', LOGIN_TYPE.EMAIL);
      this.login(email, password);
    },
    login(email, password) {
      this.isLoading = true;

      this.$store.dispatch('logIn', { email, password })
        .then((result) => {
          this.isLoading = false;

          if (result.status === RESPONSE.SUCCESS.CODE) {
            const qCnt = result.data.qCnt;
            if (qCnt || qCnt === 0) {
              this.$store.dispatch('setQCnt', { qCnt }).then();
              // eslint-disable-next-line
              if (qCnt == TEST.MAXIMUM) {
                // Check add friends available
                const friendSeqId = Object.prototype.hasOwnProperty.call(localStorage, 'addUserSeqId') ?
                  localStorage.getItem('addUserSeqId') : null;
                localStorage.removeItem('addUserSeqId');

                // eslint-disable-next-line
                if (friendSeqId && this.$store.getters.getUserSeqId != friendSeqId) {
                  this.$store.dispatch('addFriend', { friendSeqId })
                    .then(({ status, error }) => {
                      if (status === 500) {
                        this.friendsModalBody = '한명이 문제를 다 풀지 않았습니다.';
                        this.friendsModal = true;
                      } else if (status === 400 && error.resultCode === -200) {
                        this.friendsModalBody = error.resultMsg;
                        this.friendsModal = true;
                      } else if (status === 400 && error.resultCode === -300) {
                        this.friendsModalBody = error.resultMsg;
                        this.friendsModal = true;
                      } else {
                        this.friendsModalBody = this.$i18n.t('mc6.friends.done');
                        this.friendsModal = true;
                      }
                    });
                } else {
                  this.goPage('/mc6');
                }
              } else {
                this.goPage('/test/intro');
              }
            } else {
              this.goPage('/test/intro');
            }
          } else {
            if (Object.prototype.hasOwnProperty.call(result, 'error')) {
              if (result.status === 400 && result.error.resultCode === 400) {
                this.msgModal = this.$i18n.t('error.invalid.auth');
              } else {
                this.titleModal = this.$i18n.t('error.title');
                this.msgModal = `[${result.status}:${result.error.resultCode}]
                  : ${result.error.resultMsg}`;
              }
            } else if (Object.prototype.hasOwnProperty.call(result, 'data')) {
              this.titleModal = this.$i18n.t('error.title');
              this.msgModal = `[${result.status}:${result.data.resultCode}]
                : ${result.data.resultMsg}`;
            } else {
              this.titleModal = this.$i18n.t('error.title');
              this.msgModal = this.$i18n.t('error.undefined');
            }
            this.showModal = true;

            this.$store.commit('setLoginType', LOGIN_TYPE.NONE);
          }
        });
    },

    // Facebook login - Begin
    initFb() {
      try {
        FB.api('/me', { fields: 'id,name,email,picture' }, (res2) => {
          if (Object.prototype.hasOwnProperty.call(res2, 'error')) {
            FB.getLoginStatus((response) => {
              this.facebookStatus = response.status;
              this.isFbReady = true;
            });
          }
        });
      } catch (e) {
        if (e instanceof ReferenceError) {
          loadFbSdk(SOCIAL.FACEBOOK_APP_ID, SOCIAL.FACEBOOK_API_VERSION)
            .then(() => {
              FB.getLoginStatus((response) => {
                this.facebookStatus = response.status;
                this.isFbReady = true;
              });
            });
        }
      }
    },
    performFbLogin() {
      if (this.isFbReady) {
        this.$store.commit('setLoginType', LOGIN_TYPE.FACEBOOK);

        try {
          const status = this.facebookStatus;
          if (status === 'connected') {
            this.fbRequest();
          } else if (status === 'not_authorized' || status === 'unknown') {
            FB.login(() => {
              this.fbRequest();
            }, { scope: 'email' });
          }
        } catch (exception) {
          if (exception instanceof ReferenceError) {
            this.initFb();
          }
        }
      } else {
        this.msgModal = this.$i18n.t('error.trackingProtection');
        this.showModal = true;
      }
    },
    fbRequest() {
      FB.api('/me', { fields: 'id,name,email,picture' }, (res2) => {
        if (Object.prototype.hasOwnProperty.call(res2, 'error')) {
          this.initFb();
        } else {
          const userId = res2.email;
          const password = res2.id;
          this.checkSnsId(userId, password);
        }
      });
    },
    // Facebook login - End

    // Kakao login - Begin
    initKakao() {
      Kakao.init(SOCIAL.KAKAO_CLIENT_ID);
    },
    performKakaoLogin() {
      this.isLoading = true;
      const vm = this;
      this.$store.commit('setLoginType', LOGIN_TYPE.KAKAO);

      Kakao.Auth.login({
        success(authObj) {
          const scope = authObj.scope.split();
          if (scope && scope.length > 0) {
            const emailExist = scope.filter(
              info => info.search('email') > 0);

            if (emailExist && emailExist.length > 0) {
              vm.doLoginKakaoAcc();
            } else {
              vm.kakaoConsentEmail(vm.$i18n.t('error.consentProvideEmail'));
            }
          } else {
            vm.kakaoConsentEmail(vm.$i18n.t('error.consentProvideEmail'));
          }
        },
        fail(err) { // eslint-disable-line no-unused-vars
          vm.kakaoConsentEmail('Kakao login failed.');
        },
      });
    },
    doLoginKakaoAcc() {
      const vm = this;

      Kakao.API.request({
        url: '/v2/user/me',
        success(result) {
          if (Object.prototype.hasOwnProperty.call(result, 'id') &&
            Object.prototype.hasOwnProperty.call(result, 'kakao_account')) {
            const id = result.id.toString();
            const kakaoEmail = result.kakao_account.email;
            vm.checkSnsId(kakaoEmail, id);
          } else {
            vm.kakaoConsentEmail('Error : Parameter is insufficient');
          }
        },
        fail(errorObj) {
          vm.kakaoConsentEmail(JSON.stringify(errorObj));
        },
      });
    },
    kakaoConsentEmail(message) {
      this.msgModal = message;
      this.showModal = true;
      this.kakaoUnlink();
    },
    kakaoUnlink() {
      Kakao.API.request({
        url: '/v1/user/unlink',
      });
      this.isLoading = false;
      this.$store.commit('setLoginType', LOGIN_TYPE.NONE);
    },
    // Kakao login - End

    checkSnsId(email, password) {
      const params = {
        userId: email,
        password,
      };

      this.$store.dispatch('checkSnsUserId', params)
        .then((result) => {
          if (result.status === RESPONSE.SUCCESS.CODE) {
            this.login(email, password);
          } else {
            if (Object.prototype.hasOwnProperty.call(result, 'error')) {
              if (result.status === 400 && result.error.resultCode === 400) {
                this.msgModal = this.$i18n.t('error.invalid.auth');
              } else {
                this.titleModal = this.$i18n.t('error.title');
                this.msgModal = `[${result.status}:${result.error.resultCode}]
                  : ${result.error.resultMsg}`;
              }
            } else if (Object.prototype.hasOwnProperty.call(result, 'data')) {
              if (result.status === -100) {
                this.kakaoUnlink();
                this.performKakaoLogin();
              } else {
                this.titleModal = this.$i18n.t('error.title');
                this.msgModal = `[${result.status}:${result.data.resultCode}]
                  : ${result.data.resultMsg}`;
              }
            } else {
              this.titleModal = this.$i18n.t('error.title');
              this.msgModal = this.$i18n.t('error.undefined');
            }
            this.showModal = true;
            this.isLoading = false;

            this.$store.commit('setLoginType', LOGIN_TYPE.NONE);
          }
        });
    },
    detectBrowser() {
      const uAgent = navigator.userAgent.toLowerCase();
      if (uAgent.indexOf('samsungbrowser') > -1) {
        this.msgModal = this.$i18n.t('error.trackingProtection');
        this.showModal = true;
      } else if (uAgent.indexOf('firefox') > -1) {
        this.msgModal = this.$i18n.t('error.trackingProtection');
        this.showModal = true;
      } else if (uAgent.indexOf('kakao') > -1) {
        this.msgModal = this.$i18n.t('error.trackingProtection');
        this.showModal = true;
      }
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  beforeMount() {
    if (!localStorage.language) {
      this.getLanguage();
    }
    this.$store.commit('setLoginType', LOGIN_TYPE.NONE);
  },
  mounted() {
    this.isShowMenu(false);
    this.initFb();
    this.initKakao();
    this.detectBrowser();

    localStorage.removeItem('setTmpUserPassword');
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-login.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-login.vue